import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import { MdLocationOn } from 'react-icons/md';
import { IoMdCloseCircle, IoMdWarning } from 'react-icons/io';
import { Container, Row, Col } from 'react-bootstrap';
import MediaQuery from "react-responsive"; // Constants
// import * as CONSTANTS from '../../constants';

import LocationInfo from './Location';
import Heading from '../heading/Heading';
import Separator from '../separator/Separator';
import ChangeLocationForm from '../forms/ChangeLocation'; // Error Handler

import InlineError from '../state/InlineError'; // Utilities

import * as UTIL from '../../util'; // Redux

import { locationDuck } from "../../ducks/location";
import { cartDuck } from "../../ducks/cart"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
var locationOperations = locationDuck.operations;
var cartOperations = cartDuck.operations;

var ChangeLocation = /*#__PURE__*/function (_Component) {
  _inherits(ChangeLocation, _Component);

  var _super = _createSuper(ChangeLocation);

  function ChangeLocation(props) {
    var _this;

    _classCallCheck(this, ChangeLocation);

    _this = _super.call(this, props);

    _this.restaurantLocationClick = function (info, id) {
      var data = {
        gtm: {
          uniqueEventId: '34',
          elementTarget: info.address1,
          elementId: id
        },
        event: 'gtm.click'
      };
      gaTracker(data);
    };

    _this.state = {
      location: {},
      results: {},
      additionalResults: {},
      count: 5,
      browserHasLocationAccess: false,
      cart: props.cart.cart
    };
    _this.setStore = _this.setStore.bind(_assertThisInitialized(_this));
    _this.updateCount = _this.updateCount.bind(_assertThisInitialized(_this));
    _this.changeZipCode = _this.changeZipCode.bind(_assertThisInitialized(_this));
    _this.getLocationByZipcode = _this.getLocationByZipcode.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ChangeLocation, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _navigator, _navigator$permission;

        var permissionStatus, hasPermission;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$permission = _navigator.permissions) === null || _navigator$permission === void 0 ? void 0 : _navigator$permission.query({
                  name: 'geolocation'
                });

              case 2:
                permissionStatus = _context.sent;
                hasPermission = (permissionStatus === null || permissionStatus === void 0 ? void 0 : permissionStatus.state) !== 'denied';
                this.setState({
                  browserHasLocationAccess: hasPermission
                });
                this.setState({
                  cart: this.cart
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.results !== this.props.results) {
        this.setState({
          results: newProps.results
        });
      }

      if (newProps.cart !== this.props.cart) {
        this.setState({
          cart: newProps.cart
        });
      }

      if (newProps.additionalResults !== this.props.additionalResults) {
        this.setState({
          additionalResults: newProps.additionalResults
        });
      }

      if (newProps.isLoading !== this.props.isLoading) {
        this.setState({
          isLoading: newProps.isLoading
        });
      }

      if (newProps.isError !== this.props.isError) {
        this.setState({
          isError: newProps.isError,
          err: newProps.err
        });
      }

      if (newProps.err !== this.props.err) {
        this.setState({
          err: newProps.err
        });
      }
    }
  }, {
    key: "updateCount",
    value: function updateCount() {
      var count = this.state.count + 5;
      this.setState({
        count: count
      });
    }
  }, {
    key: "changeZipCode",
    value: function changeZipCode(value) {
      this.props.changeZipCode(value);
    }
  }, {
    key: "getLocationByZipcode",
    value: function getLocationByZipcode() {
      return this.props.getLocationByZipcode();
    }
  }, {
    key: "setStore",
    value: function setStore(store) {
      // Set the corresponding store
      var locationIds = UTIL.locationIdsUrl();

      if (typeof this.props.setLocation === 'function') {
        this.props.setLocation(store, Object.keys(locationIds).length ? locationIds.retaincart : "false");
      } // // Close the modal


      if (typeof this.props.setStoreHandler === 'function') {
        this.props.setStoreHandler();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$cart,
          _this$props$cart$cart,
          _this$props$cart2,
          _this2 = this;

      var additionalStores = this.props.additionalResults || this.props.results;
      var cartLength = (_this$props$cart = this.props.cart) === null || _this$props$cart === void 0 ? void 0 : (_this$props$cart$cart = _this$props$cart.cart) === null || _this$props$cart$cart === void 0 ? void 0 : _this$props$cart$cart.length;
      var retailCart = (_this$props$cart2 = this.props.cart) === null || _this$props$cart2 === void 0 ? void 0 : _this$props$cart2.isRetail;
      var useMyLocation = this.state.browserHasLocationAccess ? /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.state.browserHasLocationAccess ? function () {} : this.getCurrentLocation()
      }, /*#__PURE__*/React.createElement(MdLocationOn, {
        className: "cb-location-banner__icon cb-color-blue-500"
      }), /*#__PURE__*/React.createElement(Heading, {
        level: "4",
        field: {
          'value': 'Use my location'
        },
        className: "cb-l-inline cb-type-title"
      })) : /*#__PURE__*/React.createElement("a", {
        href: "#",
        style: {
          cursor: 'none'
        },
        onClick: function onClick() {
          alert("You must enable location access to use this feature");
        },
        disabled: true
      }, /*#__PURE__*/React.createElement(MdLocationOn, {
        className: "cb-location-banner__icon cb-color-blue-500"
      }), /*#__PURE__*/React.createElement(Heading, {
        disabled: true,
        level: "4",
        field: {
          'value': 'Use my location'
        },
        className: "cb-l-inline cb-type-title"
      }));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, !this.props.hideHeader && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
        level: "2",
        field: {
          'value': 'Search for location'
        },
        className: "cb-l-inline cb-type-title cb-l-margin-small--bottom cb-location-modal__heading"
      }))), /*#__PURE__*/React.createElement(Row, null, this.props.showCurrent ? /*#__PURE__*/React.createElement(Col, {
        md: "auto"
      }, useMyLocation, " or") : null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ChangeLocationForm, {
        store: this.props.store,
        submitHandler: this.getLocationByZipcode,
        changeHandler: this.changeZipCode,
        error: this.props.err,
        setStore: this.props.setStoreHandler
      }), this.state.browserHasLocationAccess === false && (cartLength == undefined || cartLength == 0) && retailCart === false ? /*#__PURE__*/React.createElement("div", {
        className: "d-flex"
      }, /*#__PURE__*/React.createElement(MediaQuery, {
        minWidth: 991
      }, /*#__PURE__*/React.createElement(IoMdCloseCircle, {
        size: '2em',
        className: "cb-color-red-500 align-self-center mr-2"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger align-self-center "
      }, "Your location sharing is turned off. Please share your location or search using city and state or zip code.")), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: 990
      }, /*#__PURE__*/React.createElement(IoMdCloseCircle, {
        size: '2em',
        className: "cb-color-red-500 align-self-center mr-2 "
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger align-self-center",
        style: {
          textDecoration: 'none',
          fontSize: '.75rem',
          lineHeight: '1rem'
        }
      }, "Your location sharing is turned off. Please share your location or search using city and state or zip code."))) : null, cartLength !== undefined && cartLength !== 0 && retailCart === false ? /*#__PURE__*/React.createElement("div", {
        className: "d-flex",
        style: {
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement(MediaQuery, {
        minWidth: 991
      }, /*#__PURE__*/React.createElement(IoMdWarning, {
        size: '1em',
        className: "text-danger align-self-center mr-2"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger align-self-center "
      }, "Changing Locations will clear your cart.")), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: 990
      }, /*#__PURE__*/React.createElement(IoMdWarning, {
        size: '1em',
        className: "text-danger align-self-center mr-2"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger align-self-center",
        style: {
          textDecoration: 'none',
          fontSize: '.75rem',
          lineHeight: '1rem'
        }
      }, "Changing Locations will clear your cart."))) : null, /*#__PURE__*/React.createElement(Separator, {
        image: "0",
        display: "default",
        topPadding: "xxsmall",
        bottomPadding: "xxsmall",
        className: "cb-l-margin-xsmall--bottom"
      }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, this.props.isError && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InlineError, {
        store: this.props.store,
        error: this.props.err,
        category: "location"
      })), !this.props.isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        className: "text-right"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          try {
            var _this2$props;

            _this2 === null || _this2 === void 0 ? void 0 : (_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : _this2$props.changeLocationHandler(e);
          } catch (error) {
            console.error(error);
          }

          setTimeout(function () {
            window.location = '/locations';
          }, 300);
        },
        className: "cb-type-title cb-l-margin-xsmall--vertical w-25 cb-location-modal__map-view",
        style: {
          textAlign: "end"
        }
      }, "Map View"))), /*#__PURE__*/React.createElement(Row, {
        style: {
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: "cb-location__list"
      }, additionalStores.filter(function (info) {
        return info.DiscoverableGhostKitchen !== true;
      }).map(function (info, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: "store-".concat(index),
          className: "locationList",
          style: {
            display: _this2.state.count > index ? '' : 'none',
            height: 100
          }
        }, /*#__PURE__*/React.createElement(LocationInfo, {
          className: "cb-location-banner__change",
          overrideStore: info,
          id: "store-".concat(index),
          store: _this2.props.store,
          isLoading: _this2.props.isLoading,
          isError: _this2.props.isError,
          err: _this2.props.err,
          changeLocationHandler: function changeLocationHandler() {
            _this2.restaurantLocationClick(info, "store-".concat(index));

            return _this2.setStore(info);
          }
        }));
      })), (additionalStores === null || additionalStores === void 0 ? void 0 : additionalStores.length) > 1 ? /*#__PURE__*/React.createElement("button", {
        onClick: this.updateCount,
        className: "cb-button-secondary",
        style: {
          display: this.state.count === 25 ? "none" : ''
        }
      }, "Show More") : '')) : /*#__PURE__*/React.createElement("p", {
        className: "is-fetching"
      }, "Loading")))));
    }
  }]);

  return ChangeLocation;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    location: state.location.location,
    results: state.location.results,
    additionalResults: state.location.additionalResults,
    isLoading: state.location.isLoadingZipcode,
    isError: state.location.isError,
    err: state.location.err,
    //|| state.error.err
    cart: state.cart
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setLocation: function setLocation(location, retaincart) {
      return dispatch(locationOperations.setLocation(location, retaincart));
    },
    changeZipCode: function changeZipCode(text) {
      return dispatch(locationOperations.changeZipCode(text));
    },
    getLocationByZipcode: function getLocationByZipcode() {
      return dispatch(locationOperations.getLocationByZipcode());
    },
    handleError: function handleError(err) {
      return dispatch(locationOperations.getError(err));
    },
    getCart: function getCart() {
      return dispatch(cartOperations.getCart());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLocation);